import React, { useState, useEffect, useRef } from "react";
import ReactPlayer from "react-player";
import { supabase } from "../supabase";

function VideoPlayer({ deviceId }) {
  const [videoUrl, setVideoUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const playerRef = useRef(null);

  useEffect(() => {
    const fetchVideo = async () => {
      try {
        const { data: device } = await supabase
          .from("tv_devices")
          .select("group_id")
          .eq("device_id", deviceId)
          .single();

        if (device?.group_id) {
          const { data: config } = await supabase
            .from("slides_config")
            .select("slides_path")
            .eq("group_id", device.group_id)
            .order("created_at", { ascending: false });

          if (config) {
            if (config[0].slides_path.includes("https://")) {
              setVideoUrl(config[0].slides_path);
            } else {
              const {
                data: { publicUrl },
              } = supabase.storage
                .from("slides")
                .getPublicUrl(config[0].slides_path);

              setVideoUrl(publicUrl);
            }
          }
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching video:", error);
        setLoading(false);
      }
    };

    fetchVideo();

    // Subscribe to changes in both tv_devices and slides_config
    const deviceChannel = supabase
      .channel("tv_devices_changes")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "tv_devices",
          filter: `device_id=eq.${deviceId}`,
        },
        fetchVideo
      )
      .subscribe();

    const configChannel = supabase
      .channel("slides_config_changes")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "slides_config",
        },
        fetchVideo
      )
      .subscribe();

    // Request fullscreen when component mounts
    const enterFullScreen = () => {
      const element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      }
    };
    enterFullScreen();

    return () => {
      supabase.removeChannel(deviceChannel);
      supabase.removeChannel(configChannel);
      // Exit fullscreen when component unmounts
      if (document.exitFullscreen && document.fullscreenElement) {
        document.exitFullscreen();
      }
    };
  }, [deviceId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-black text-white">
        Loading...
      </div>
    );
  }

  if (!videoUrl) {
    return (
      <div className="flex items-center justify-center h-screen bg-black text-white">
        No video configuration found
      </div>
    );
  }

  return (
    <div className="h-screen bg-black flex items-center justify-center">
      <ReactPlayer
        ref={playerRef}
        url={videoUrl}
        width="100%"
        height="100%"
        playing={true}
        loop={true}
        controls={false}
        muted={true}
        playsinline={true}
        config={{
          file: {
            attributes: {
              style: {
                width: "100%",
                height: "100%",
                objectFit: "contain",
              },
            },
          },
        }}
      />
    </div>
  );
}

export default VideoPlayer;
